module.exports = __webpack_public_path__ + "img/02.4ff94a98.jpg";